import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Users } from 'lucide-react';
import { KpiGrid, SectionHeader, ExportButtons, ReportTable, fIDR, fIDRCompact, fDateID } from './shared';

const RISK_BADGE = {
  High: 'bg-red-400/15 text-red-300 border-red-400/30',
  Medium: 'bg-amber-400/15 text-amber-300 border-amber-400/30',
  Low: 'bg-emerald-400/15 text-emerald-300 border-emerald-400/30',
};

export function ClientsTab({ data, loading, filters }) {
  const s = data?.summary || {};
  const cards = [
    { label: 'Total Client', value: s.total_client || 0, accent: '' },
    { label: 'Client Aktif (Periode)', value: s.active_client || 0, accent: 'success' },
    { label: 'Client dengan Outstanding', value: s.client_with_outstanding || 0, accent: 'warn' },
    { label: 'Client Overdue', value: s.client_overdue || 0, accent: 'danger' },
    { label: 'Total Invoice', value: fIDRCompact(s.total_invoice), accent: '' },
    { label: 'Total Paid', value: fIDRCompact(s.total_paid), accent: 'success' },
    { label: 'Total Outstanding', value: fIDRCompact(s.total_outstanding), accent: 'warn' },
    { label: 'Total Overdue', value: fIDRCompact(s.total_overdue), accent: 'danger' },
  ];
  const rows = data?.rows || [];
  return (
    <div className="space-y-4">
      <SectionHeader icon={Users} title="Laporan Client" action={<ExportButtons tab="clients" filters={filters} />} />
      <KpiGrid items={cards} loading={loading} columns={4} />
      <Card className="bg-card border-border">
        <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-100">Detail Performance Client ({rows.length})</CardTitle></CardHeader>
        <CardContent className="p-0 sm:p-4">
          <ReportTable
            getRowKey={(r) => r.client_id}
            columns={[
              { key: 'risk_status', label: 'Risk', render: r => <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium ${RISK_BADGE[r.risk_status] || RISK_BADGE.Low}`}>{r.risk_status}</span> },
              { key: 'client_name', label: 'Client', render: r => <span className="font-medium text-slate-100">{r.client_name}</span> },
              { key: 'invoice_count', label: 'Jml Inv', align: 'right', render: r => <span className="text-slate-200">{r.invoice_count}</span> },
              { key: 'total_invoice', label: 'Total Invoice', align: 'right', render: r => <span className="font-mono-num text-slate-100">{fIDR(r.total_invoice)}</span> },
              { key: 'total_paid', label: 'Total Paid', align: 'right', render: r => <span className="font-mono-num text-emerald-300">{fIDR(r.total_paid)}</span> },
              { key: 'outstanding', label: 'Outstanding', align: 'right', render: r => <span className="font-mono-num text-amber-200">{fIDR(r.outstanding)}</span> },
              { key: 'overdue', label: 'Overdue', align: 'right', render: r => <span className="font-mono-num text-red-300">{fIDR(r.overdue)}</span> },
              { key: 'overdue_count', label: 'Inv Overdue', align: 'right', render: r => <span className="text-rose-300">{r.overdue_count}</span> },
              { key: 'avg_days_to_pay', label: 'Avg Hari Bayar', align: 'right', render: r => <span className="text-slate-300">{r.avg_days_to_pay}d</span> },
              { key: 'last_payment_date', label: 'Last Payment', render: r => <span className="text-xs text-slate-400">{r.last_payment_date ? fDateID(r.last_payment_date) : '—'}</span> },
              { key: 'collection_rate', label: 'Coll. %', align: 'right', render: r => <span className="font-mono-num text-slate-100">{r.collection_rate}%</span> },
            ]}
            rows={rows}
            emptyText="Belum ada data untuk periode ini."
            mobileCard={(r) => (
              <div className="text-sm space-y-1">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium ${RISK_BADGE[r.risk_status] || RISK_BADGE.Low}`}>{r.risk_status}</span>
                    <div className="font-semibold text-slate-100 truncate mt-1">{r.client_name}</div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-1 text-xs text-slate-300 mt-2">
                  <div>Inv: <span className="text-slate-100">{r.invoice_count}</span></div>
                  <div>Total: <span className="font-mono-num text-slate-100">{fIDR(r.total_invoice)}</span></div>
                  <div>Paid: <span className="font-mono-num text-emerald-300">{fIDR(r.total_paid)}</span></div>
                  <div>Out: <span className="font-mono-num text-amber-200">{fIDR(r.outstanding)}</span></div>
                  <div>Overdue: <span className="font-mono-num text-red-300">{fIDR(r.overdue)}</span></div>
                  <div>Coll: <span className="text-slate-100">{r.collection_rate}%</span></div>
                </div>
              </div>
            )}
          />
        </CardContent>
      </Card>
    </div>
  );
}
